import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import LastNameField_en from './locales/LastNameField_en.json';
import LastNameField_fr from './locales/LastNameField_fr.json';

class LastNameField extends React.Component {

  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'LastNameField', LastNameField_en);
    i18next.addResourceBundle('fr', 'LastNameField', LastNameField_fr);
  }

  render() {
    const { t, form, className } = this.props;
    const { getFieldDecorator } = form;

    const placeholder = (
      this.props.placeholder === true ?
        t('FIELDS:last-name') :
        this.props.placeholder || null
    );

    const input = <Input placeholder={placeholder} />;
    const fieldId = 'lastname';
    const fieldOptions = {
      rules: [
        {// Required validation
          required: this.props.required,
          message: this.props.requiredMessage || t('required')
        },
        {// Characters validation
          pattern: /^[a-zA-Z0-9\u00C0-\u017F ,-\\']+$/,
          message: this.props.validationMessage || t('validation')
        },
        {// Length validation
          pattern: /^.{2,50}$/,
          message: t('maximum')
        }
      ],
      initialValue: this.props.initialValue
    };

    const label = (
      this.props.label ?
        t('FIELDS:last-name') :
        this.props.label || null
    );

    return (
      <Form.Item
        className={className}
        label={label}
        hasFeedback
      >
        {getFieldDecorator(fieldId, fieldOptions)(input)}
      </Form.Item>
    );
  }

}

LastNameField.defaultProps = {
  label: true,
  placeholder: false,
  required: true,
  requiredMessage: null,
  validationMessage: null,
  initialValue: undefined,
};

LastNameField.propTypes = {
  form: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default translate('LastNameField')(LastNameField);
